/**
 * @file 事件总线
 * @author huyang(huyang2229@gmail.com)
 */

import Vue from 'vue';

// 全局事件总线
export default new Vue();



// WEBPACK FOOTER //
// ./src/event-bus.js